export const SERVER_ERROR = 'SERVER_ERROR'